export enum Size {
  Small = "small",
  Med   = "medium",
  Large = "large",
}
